export default __webpack_public_path__ + "static/media/dragonsushi.14edf9ad.PNG";